<template>
  <Popup @close="$emit('close')">
    <template #header>
      <div class="w-full text-center p-2">
        <h1 class="text-2xl">
          {{ $t('SelfPerform.PlantDashboard.NewHirePeriodModal.title') }}
        </h1>
      </div>
    </template>

    <template #body>
      <div class="h-full w-full overflow-y-auto">
        <form
          action=""
          class="flex-col space-y-4 flex"
          @submit.prevent="updateHirePeriod"
        >
          <label class="space-y-2">
            <p class="text-sm font-semibold">
              {{ $t('SelfPerform.PlantDashboard.NewHirePeriodModal.label.onHireDate') }}
            </p>

            <AppInput
              v-model="hirePeriodForm.form.on_hired_at"
              name="on_hired_at"
              type="date"
              :error="hirePeriodForm.getErrors('on_hired_at')"
              data-test="new-hired-on-hire"
              class="form-input"
            />
          </label>

          <label class="space-y-2">
            <p class="text-sm font-semibold">
              {{ $t('SelfPerform.PlantDashboard.NewHirePeriodModal.label.offHireDate') }}
            </p>

            <AppInput
              v-model="hirePeriodForm.form.off_hired_at"
              name="off_hired_at"
              type="date"
              :error="hirePeriodForm.getErrors('off_hired_at')"
              data-test="new-hired-off-hire"
              class="form-input"
            />
          </label>
        </form>
      </div>
    </template>

    <template #footer>
      <div class="w-full flex justify-center p-2 space-x-4">
        <button
          type="button"
          class="btn btn--secondary-blue w-1/2"
          @click="$emit('close'); hirePeriodForm.resetData()"
        >
          {{ $t('SelfPerform.PlantDashboard.NewHirePeriodModal.button.cancel') }}
        </button>

        <button
          type="button"
          class="btn btn--primary-blue w-1/2 disabled:bg-gray-700"
          :disabled="hireLoading"
          data-test="save-new-hire-period"
          @click="updateHirePeriod"
        >
          {{ $t('SelfPerform.PlantDashboard.NewHirePeriodModal.button.save') }}
        </button>
      </div>
    </template>
  </Popup>
</template>

<script setup lang="ts">
import Popup from '@/components/Popup.vue';
import { useFormData } from '@/composables/useFormData';
import { useStoreApiAction } from '@/composables/useStoreApiAction';
import { usePlantsStore } from '@/store/plants';

const props = defineProps<{
  plantId: Id;
}>();

const emits = defineEmits<{
  (e: 'close');
}>();

const plantsStore = usePlantsStore();

const hirePeriodForm = useFormData({
  on_hired_at: '',
  off_hired_at: '',
});

const { loading: hireLoading, request: saveHire } = useStoreApiAction(plantsStore.hire);

const updateHirePeriod = () => {
  hirePeriodForm.resetErrors();

  saveHire(props.plantId, hirePeriodForm.form).then((_data) => {
    emits('close');
    hirePeriodForm.resetData();
  }).catch((error) => {
    hirePeriodForm.setErrors(error.data);
  });
};
</script>

<style scoped></style>
